<template>
    <el-dialog :title="title"
               width="40%"
               :visible="showDialog"
               @open="create"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               append-to-body
               :show-close="false">
        <div class="row">
            <div class="col-md-12" v-if="allLotsGroup.length > 0">
                <div class="">Seleccionar Lote(s)</div>
                <el-select v-model="lotsGroupSelected"
                           multiple
                           @change="changeLotsGroup">
                    <el-option v-for="option in allLotsGroup"
                               :key="option.id"
                               :label="option.code"
                               :value="option.code">
                        <span style="float: left">{{ option.code }} ({{ option.quantity }})</span>
                        <span style="float: right; color: #8492a6; font-size: 13px">{{ option.date_of_due }}</span>
                    </el-option>
                </el-select>

                <!--                    <x-select label="Seleccionar Lote"-->
                <!--                              :options="lotsGroup"-->
                <!--                              option-label="lot_code"></x-select>-->
            </div>
            <div class="col-md-12" style="margin-top: 8px">
                <x-input label="Buscar serie"
                         v-model="searchLot"
                         @input="changeSearchLot"></x-input>
            </div>
            <div class="col-md-12" v-if="lotsSelected.length > 0">
                <div style="width: 100%">Series seleccionadas:</div>
                <div style="width: 100%">{{ showLots(lotsSelected) }}
                    <el-tag v-for="l in lotsSelected"
                            :key="l">
                        {{ showLots(l) }}
                    </el-tag>
                </div>
            </div>
            <div class="col-md-12" v-loading="loading">
                <div class="table-responsive mt-3">
                    <table class="table">
                        <thead>
                        <tr>
                            <th class="text-center">#</th>
                            <th class="text-center">Seleccionar</th>
                            <th v-if="allLotsGroup.length > 0">Cod. Lote</th>
                            <th>Serie</th>
                            <th class="text-center">F.Ingreso</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(row, index) in lots" :key="index">
                            <td class="text-center">
                                {{ index + 1 }}
                            </td>
                            <td class="text-center">
                                <el-checkbox v-model="row.selected"
                                             @change="changeLot(row)"></el-checkbox>
                            </td>
                            <td v-if="allLotsGroup.length > 0">
                                {{ row.lot_code }}
                            </td>
                            <td>
                                {{ row.series }}
                            </td>
                            <td class="text-center">
                                {{ row.date }}
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="col-12 text-right" style="margin-top: 16px">
                <el-button @click.prevent="close">Cerrar</el-button>
                <el-button type="primary"
                           :disabled="quantity <= 0"
                           @click="submit">Aceptar
                </el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>

import XSelect from "../../../../components/Form/XSelect.vue"
import XInput from "../../../../components/Form/XInput.vue"

export default {
    name: 'SeriesList',
    components: {XInput, XSelect},
    props: ['showDialog', 'item', 'warehouseId', 'selectedLots', 'table', 'tableItemId'],
    data() {
        return {
            title: 'Seleccionar lotes y/o series',
            loading: false,
            errors: {},
            form: {},
            allLotsGroup: [],
            allLots: [],
            lotsGroupSelected: [],
            lots: [],
            lotsSelected: [],
            searchLot: ''
        }
    },
    computed: {
        quantity() {
            return this.lotsSelected.length
        }
    },
    methods: {
        async create() {
            this.initForm()
            this.lotsSelected = this.selectedLots ? this.selectedLots.map(l => l.id) : []
            await this.initTables()
            this.changeLotsGroup()
        },
        initForm() {
            console.log('initForm')
            this.allLotsGroup = []
            this.allLots = []
            this.lotsGroupSelected = []
            this.lots = []
            this.lotsSelected = []
            this.searchLot = ''
        },
        async initTables() {
            console.log('initTables')
            this.loading = true
            await this.$http.post(`/documents/item_lots_group`, {
                item_id: this.item.id,
                table: this.table,
                table_item_id: this.tableItemId
            })
                .then((response) => {
                    this.allLotsGroup = response.data
                })
                .catch(error => {
                })
                .then(() => {
                    this.loading = false
                })
            this.loading = true
            await this.$http.post(`/documents/item_lots_2`, {
                item_id: this.item.id,
                warehouse_id: this.warehouseId,
                table: this.table,
                table_item_id: this.tableItemId
            })
                .then((response) => {
                    this.allLots = response.data
                })
                .catch(error => {
                })
                .then(() => {
                    this.loading = false
                })
        },
        changeLotsGroup() {
            console.log('changeLotsGroup')
            this.lots = []
            this.allLots.forEach(row => {
                if (row.warehouse_id === this.warehouseId) {
                    let exist = true
                    if (this.lotsGroupSelected.length > 0) {
                        exist = this.lotsGroupSelected.some(lot => lot === row.lot_code)
                    }
                    if (this.searchLot !== '' && exist) {
                        exist = row.series.toLowerCase().includes(this.searchLot.toLowerCase())
                    }
                    let isSelected = this.lotsSelected.some(lot => lot === row.id)
                    if (exist) {
                        this.lots.push({
                            id: row.id,
                            series: row.series,
                            lot_code: row.lot_code,
                            date: row.date,
                            selected: isSelected,
                            has_sale: isSelected,
                        })
                    }
                }
            })
        },
        changeSearchLot() {
            console.log('changeSearchLot')
            this.changeLotsGroup()
        },
        changeLot(row) {
            console.log('changeLot')
            let index = this.lotsSelected.indexOf(row.id)
            if (index > -1) {
                this.lotsSelected.splice(index, 1)
            } else {
                this.lotsSelected.push(row.id)
            }
        },
        showLots(id) {
            console.log('showLots')
            let lots = this.allLots.find(row => {
                return row.id === id
            })
            if (lots) {
                return lots.series
            }
        },
        submit() {
            console.log('submit')
            let dataLotsGroup = []
            let dataLots = []
            this.allLots.forEach(row => {
                let selected = this.lotsSelected.some(lot => lot === row.id)
                if (selected) {
                    dataLots.push({
                        id: row.id,
                        date: row.date,
                        series: row.series,
                        item_id: row.item_id,
                        has_sale: true,
                        lot_code: row.lot_code,
                        warehouse_id: row.warehouse_id,
                    })
                }
            })

            this.allLotsGroup.forEach(row => {
                let lots = dataLots.filter(lot => lot.lot_code === row.code)
                if (lots.length > 0) {
                    dataLotsGroup.push({
                        id: row.id,
                        code: row.code,
                        date_of_due: row.date_of_due,
                        quantity: row.quantity,
                        compromise_quantity: lots.length
                    })
                }
            })

            this.$emit('success', {
                lotsGroup: dataLotsGroup,
                lots: dataLots,
            })
            this.close()
        },
        close() {
            this.$emit('update:showDialog', false)
        },
    }
}
</script>
